// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"a0dcb26e","520":"496d62ad","621":"b8b93e49","808":"28af25ba"}[chunkId] + ".css";
};